import { useEffect } from "react";

export function useFilingRedirects({
  isCpa,
  searchParams,
  setSearchParams,
  modalState
}) {
  const {
    setShowAcceptedPopup,
    setShowDemoWelcomeModal
  } = modalState;

  useEffect(() => {
    // 1. Check if CPA just accepted the filing
    if (isCpa && searchParams.get("accepted") === "true") {
      setShowAcceptedPopup(true);
      
      // Clean up the URL without a page reload
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("accepted");
      setSearchParams(newParams, { replace: true });
    }

    // 2. Check if Customer should see Demo Welcome
    const showDemoWelcome = searchParams.get("demo_welcome") === "true";
    if (showDemoWelcome && !isCpa) {
      setShowDemoWelcomeModal(true);
      
      // Clean up the URL
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("demo_welcome");
      setSearchParams(newParams, { replace: true });
    }
  }, [isCpa, searchParams, setSearchParams, setShowAcceptedPopup, setShowDemoWelcomeModal]);
}